// src/components/legal/LegalDocumentModal.jsx
// Copyright (c) 2025 Nebularis Holdings LLC
// See IP License Agreement for usage restrictions.

import React from "react";

import Modal from "../../design-system/components/overlays/Modal";
import LegalDocumentRenderer from "./LegalDocumentRenderer";
import { getLegalDocument } from "./legalDocuments";
import "./LegalDocument.css";

export default function LegalDocumentModal({
  documentKey,
  open = false,
  onClose,
  onOpenFullPage,
}) {
  const document = getLegalDocument(documentKey);

  if (!document) return null;

  const actions = [
    {
      key: "close",
      label: "Close",
      variant: "secondary",
      onClick: onClose,
    },
  ];

  if (typeof onOpenFullPage === "function") {
    actions.push({
      key: "full-page",
      label: "Open full page",
      variant: "primary",
      onClick: () => onOpenFullPage(document.routeMode),
    });
  }

  return (
    <Modal
      open={open}
      eyebrow={document.eyebrow}
      title={document.title}
      description={document.description}
      onClose={onClose}
      actions={actions}
      footerNote={`Version ${document.version} • Effective ${document.effectiveDate}`}
      size="large"
      theme="inherit"
      className="legal-modal"
      bodyClassName="legal-modal__body"
    >
      <LegalDocumentRenderer document={document} />
    </Modal>
  );
}
